import { Modal } from 'components/Modal';
import styles from './ModalConfirm.module.scss';
import { Title } from 'components/Title';
import { Button } from 'ui/Button';
import iconClose from './img/iconClose.svg';

export const ModalConfirm = ({
  setShowLogoutModal,
  title,
  text,
  confirmText,
  onConfirm,
  cancelText = 'Отмена',
  subText,
}: {
  setShowLogoutModal: (e: boolean) => void;
  title: string;
  text: string;
  confirmText?: string;
  onConfirm: () => void;
  cancelText?: string;
  subText?: React.ReactNode;
}) => {
  return (
    <Modal setOpen={setShowLogoutModal}>
      <div className={styles.root}>
        <Title className={styles.root_title} title={title} />
        <p className={styles.root_text}>{text}</p>
        {subText ? subText : null}
        <div className={styles.root_btn}>
          {confirmText && (
            <Button
              onClick={() => {
                setShowLogoutModal(false);
                onConfirm();
              }}
              icon
              src={iconClose}
              className={styles.root_btn_exit}
              theme='danger'>
              {confirmText}
            </Button>
          )}

          <Button
            onClick={() => setShowLogoutModal(false)}
            theme='filed'
            className={styles.root_btn_cancel}>
            {cancelText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
